import React from 'react';
import PropTypes from 'prop-types';
import PlanDestinationBox from './PlanDestinationBox';
import Spacer from '../Spacer';

const Destinations = ({ destinations, handleDestinationSelection }) => {
  const destinationsList = destinations.map(destination => (
    <PlanDestinationBox
      key={destination.id}
      destination={destination}
      soldOut={destination.status === 'sold_out'}
      handleDestinationSelection={() => handleDestinationSelection(destination.id)}
    />
  ));
  return (
    <div className="dui-container dui-mx-auto">
      <div className='dui-text-center'>
        <h3 className="dui-text-2xl lg:dui-text-6xl dui-font-heading !dui-font-normal dui-text-primary-950 dui-uppercase">Choose a destination</h3>
        <p className='dui-mt-4'>
          Each route is unique and has varying degrees of party, culture and exploration
        </p>
      </div>
      <Spacer />
      <div className="dui-grid dui-grid-cols-1 sm:dui-grid-cols-2 lg:dui-grid-cols-3 dui-gap-8">
        {destinationsList}
      </div>
    </div>
  );
};

Destinations.propTypes = {
  destinations: PropTypes.array.isRequired,
  handleDestinationSelection: PropTypes.func.isRequired
};

export default Destinations;
